import GoCheckboxInput from "./go-checkbox-input.vue";

export default GoCheckboxInput;



// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/go-checkbox-input/index.js